<template>
  <div class="title-box">
    <p>{{ t('home.k04rdq') }}</p>
    <a-spin :spinning="spinning" :delay="200">
      <a-input-group compact class="input">
        <a-select v-model:value="searchType" style="width: 33%" @change="handleSearchTypeChange">
          <a-select-option :value="1">{{ t('home.kgf93s') }}</a-select-option>
          <a-select-option :value="2">{{ t('home.rqp3ld') }}</a-select-option>
          <a-select-option :value="3">{{ t('home.ps4h0r') }}</a-select-option>
          <a-select-option :value="4">{{ t('home.8nyeeu') }}</a-select-option>
          <a-select-option :value="5">{{ t('home.hfm7qa') }}</a-select-option>
          <a-select-option :value="6">{{ t('home.ds23sf') }}</a-select-option>
        </a-select>
        <a-auto-complete
          :placeholder="t('home.sri2s2')"
          v-model:value="data"
          style="width: 67%"
          ref="inputSearch"
          @popupScroll="popupScroll"
          :showSearch="true"
          :filter-option="false"
          @search="search"
          allowClear
          :dropdownMatchSelectWidth="false"
          :options="optionPage"
          @select="change"
          :open="openPopup"
          @blur="onFocus(false)"
          @focus="onFocus(true)"
          @keyup.enter="handleEnter()"
        >
          <template #suffixIcon>
            <img src="@/assets/index/search.svg" class="icon icon-right" alt="" />
          </template>
          <template #option="item">
            <DcPenetrateContent style="background-color: transparent" v-if="item.value !== -9">
              <div class="pull-box">
                <p>
                  【{{ [t('home.ezjlnj'), t('home.8ho89e'), t(props.type === 'cos_ofbu' ?  'home.jdn2ws' : 'home.jdn2we'), t('home.z415qj')][item.stage - 1] }}({{
                    ['cos_fbu', 'cos_ofbu'].includes(props.type) && item.stage === 1 && item.clueType != null
                      ? item.status === 0
                        ? t('home.a27bas')
                        : [t('home.vevwzm'), t('home.hwu5bv'), t('home.u7gauo'), t('home.ti9eob')][item.clueType]
                      : props.type === 'cos_fbu' && item.stage > 1 && item.publicStatus === 1
                      ? t('home.g4h42g')
                      : statusEnum[item.status]
                  }})】{{ t('home.rqp3ld') }}：{{ item.customerName || '--' }} {{ t('home.ps4h0r') }}：{{
                    item.arkCode || item.customerSerial || '--'
                  }}
                </p>
                <template v-if="props.type === 'cos_ofbu'">
                  <p>
                    {{ t('home.8nyeeu') }}：{{ item.mobile || '--' }} {{ t('home.hfm7qa') }}：{{ item.email || '--' }}
                    {{ t('home.9sns5l') }}：{{ item.sellerName || '--' }}
                  </p>
                </template>
                <template v-else>
                  <p>
                    {{ t('home.oez6lt') }}：{{ item.tel || '--' }} {{ t('home.8nyeeu') }}：{{ item.mobile || '--' }}
                    {{ t('home.hfm7qa') }}：{{ item.email || '--' }} {{ t('home.9sns5l') }}：{{
                      item.sellerName || '--'
                    }}
                  </p>
                </template>
              </div>
              <div
                class="empit-box"
                :class="!item.hasPermission ? 'isDisable' : ''"
                v-if="!item.hasPermission"
                @click.stop=""
              ></div>
              <div class="empit-box" :class="!item.hasPermission ? 'isDisable' : ''" v-if="item.hasPermission"></div>
            </DcPenetrateContent>
            <DcPenetrateContent style="background-color: transparent" v-if="item.value === -9" @click.stop="">
              <div class="dcEmpty">
                <dc-layout-empty type="nothing" :style="{ width: '191px' }" />
              </div>
            </DcPenetrateContent>
          </template>
        </a-auto-complete>
      </a-input-group>
    </a-spin>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, computed } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { useRouter, useRoute } from 'vue-router'
import { allSearch, allSearchLbu, allSearchOFbu } from '@/api/gucangSales/businessRuleSetting'
import { debounce } from 'lodash-es'
import { ROUTERGO, ROUTERType } from './hooks/enum'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
/// 默认客户代码
const searchType = ref<number>(3)
const props = defineProps({
  value: {
    type: String || Array
  },
  type: {
    type: String,
    default: 'cos_fbu' // cos_fbu、cos_ofbu、cos_lbu
  }
})
const spinning = ref(false)
const pageNumber = ref(1)
const data = ref()
const searchTxt = ref('')
const emit = defineEmits(['update:value', 'selectData'])
const optionPage = ref<any[]>([])
// 提示语
const placeholderSearch = computed(() => (props.type === 'cos_ofbu' ? t('home.wguiy6') : t('home.wguiy5')))
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const statusEnum: any = {
  0: t('home.a27bas'),
  1: t('home.inoqrl'),
  2: t('home.ne9mdc'),
  3: t('home.pmre4f'),
  5: t('home.a27bas'),
  8: t('home.vov0jp'),
  10: t('home.2e24jh'),
  11: t('home.p5d8cm'),
  12: t('home.ni1e64'),
  13: t('home.wsdvme'),
  14: t('home.prwoss'),
  20: t('home.ahwj9u'),
  21: t('home.6twq14'),
  22: t('home.pwdrhz'),
  30: t('home.52d61f'),
  31: t('home.cxtphk'),
  32: t('home.0q8guc'),
  33: t('home.a1294c'),
  34: t('home.nfdaeq'),
  35: t('home.8g8lg9'),
  36: t('home.9d6v9g'),
  37: t('home.sda243'),
  38: t('home.jgh53d'),
  39: t('home.34hbm6')
}
const pageType = ref<string>()
const inputSearch = ref()
const openPopup = ref(true)
watch(
  () => props.type,
  () => {
    pageType.value = props.type
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  const itemData = optionPage.value.filter((item) => item.cosId === value)
  if (!itemData[0].hasPermission) {
    return
  }
  if (optionPage.value) {
    const arr = optionPage.value.filter((item) => item.cosId === value)
    emit('selectData', arr[0] ? arr[0].arkCode : '')
    if (arr.length > 0 && pageType.value && ['cos_fbu', 'cos_ofbu'].includes(pageType.value)) {
      const query = {
        cosId: arr[0].cosId,
        returnPath: route.fullPath
      }

      if (arr[0].publicStatus === 1) {
        query.isPublicClue = 1
      }
      switch (arr[0].stage) {
        case ROUTERType.FBUPOTENTIALType:
          router.push({
            path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUPOTENTIAL}` : `${ROUTERGO.OFBUPOTENTIAL}`,
            query: query
          })
          break
        case ROUTERType.FBUSIGNType:
          router.push({
            path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUSIGN}` : `${ROUTERGO.OFBUSIGN}`,
            query: query
          })

          break
        case ROUTERType.FBUSUCCESSType:
          router.push({
            path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUSUCCESS}` : `${ROUTERGO.OFBUSUCCESS}`,
            query: query
          })
          break
        case ROUTERType.FBUCLUESType:
          if (arr[0].status === 0) {
            router.push({
              path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUCLUES}` : `${ROUTERGO.OFBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath,
                isPublicClue: 1
              }
            })
          } else {
            router.push({
              path: pageType.value === 'cos_fbu' ? `${ROUTERGO.FBUCLUES}` : `${ROUTERGO.OFBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath
              }
            })
          }

          break
      }
    }
    if (arr.length > 0 && pageType.value === 'cos_lbu') {
      switch (arr[0].stage) {
        case ROUTERType.LBUPOTENTIALType:
          router.push({
            path: `${ROUTERGO.LBUPOTENTIAL}`,
            query: {
              cosId: arr[0].cosId,
              returnPath: route.fullPath
            }
          })
          break
        case ROUTERType.LBUSUCCESSType:
          router.push({
            path: `${ROUTERGO.LBUSUCCESS}`,
            query: {
              cosId: arr[0].cosId,
              returnPath: route.fullPath
            }
          })
          break
        case ROUTERType.LBUCLUESType:
          if (arr[0].status === 0) {
            router.push({
              path: `${ROUTERGO.LBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath,
                isPublicClue: 1
              }
            })
          } else {
            router.push({
              path: `${ROUTERGO.LBUCLUES}`,
              query: {
                clueId: arr[0].cosId,
                returnPath: route.fullPath
              }
            })
          }
          break
      }
    }
  }
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const handleEnter = () => {
  if (data.value === -9) {
    data.value = ''
  }
}
const search = debounce(async (txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  pageNumber.value = 1
  setTimeout(() => {
    fetch()
  })
}, 500)
const onFocus = (onFocus: boolean) => {
  openPopup.value = onFocus
}
const handleSearchTypeChange = (value?: any) => {
  optionPage.value = []
  if (searchTxt.value) {
    inputSearch.value?.focus()
    openPopup.value = true
    search(searchTxt.value)
  }
}
// 获取公司下拉列表
const fetch = () => {
  if (!searchTxt.value.trim()) {
    return
  }
  spinning.value = true
  if (pageType.value === 'cos_lbu') {
    allSearchLbu({
      searchType: searchType.value,
      searchText: searchTxt.value.trim(),
      pageNumber: pageNumber.value,
      pageSize: 10
    }).then((res) => {
      spinning.value = false
      if (res.data.items.length > 0) {
        res.data.items.forEach((element: any) => {
          element.value = element.cosId
        })
      }
      const isNull = optionPage.value[0]?.value === -9
      if (!isNull) {
        if (pageNumber.value === 1) {
          optionPage.value = res.data.items
        } else {
          optionPage.value = [...optionPage.value, ...res.data.items]
        }
      } else if (res.data.items.length > 0) {
        optionPage.value = res.data.items
      }
      if (res.data.items.length === 0 && pageNumber.value === 1) {
        optionPage.value = [{ value: -9, label: '暂无数据' }]
      }
    })
  } else if (pageType.value === 'cos_fbu') {
    allSearch({
      searchType: searchType.value,
      searchText: searchTxt.value.trim(),
      pageNumber: pageNumber.value,
      pageSize: 10
    }).then((res) => {
      spinning.value = false
      if (res.data.items.length > 0) {
        res.data.items.forEach((element: any) => {
          element.value = element.cosId
        })
      }
      const isNull = optionPage.value[0]?.value === -9
      if (!isNull) {
        if (pageNumber.value === 1) {
          optionPage.value = res.data.items
        } else {
          optionPage.value = [...optionPage.value, ...res.data.items]
        }
      } else if (res.data.items.length > 0) {
        optionPage.value = res.data.items
      }
      if (res.data.items.length === 0 && pageNumber.value === 1) {
        optionPage.value = [{ value: -9, label: '暂无数据' }]
      }
    })
  } else {
    allSearchOFbu({
      searchType: searchType.value,
      searchText: searchTxt.value.trim(),
      pageNumber: pageNumber.value,
      pageSize: 10
    }).then((res) => {
      spinning.value = false
      if (res.data.items.length > 0) {
        res.data.items.forEach((element: any) => {
          element.value = element.cosId
        })
      }
      const isNull = optionPage.value[0]?.value === -9
      if (!isNull) {
        if (pageNumber.value === 1) {
          optionPage.value = res.data.items
        } else {
          optionPage.value = [...optionPage.value, ...res.data.items]
        }
      } else if (res.data.items.length > 0) {
        optionPage.value = res.data.items
      }
      if (res.data.items.length === 0 && pageNumber.value === 1) {
        optionPage.value = [{ value: -9, label: '暂无数据' }]
      }
    })
  }
}

onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'CusSelect' }
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background-color: #fff;
  width: 100%;
  height: 61px;
  margin-bottom: 16px;
  p {
    color: #666666;
    font-size: 16px;
    font-weight: 500;
    margin-left: 24px;
  }
  .input {
    width: 350px;
    background: #f9f9ff;
    border-radius: 4px;
    border: none;
    margin-left: 18px;
  }
}
.pull-box {
  // width: 500px;
  padding: 5px 10px;
  p:nth-of-type(1) {
    color: rgb(90, 118, 228);
  }
}
.pull-box:hover {
  background-color: #f9f9ff;
}
.isDisable {
  cursor: not-allowed;
}
.empit-box {
  width: 100%;
  height: 64px;
  position: absolute;
  top: 0;
  left: 0;
}
.dcEmpty {
  width: 326px;
  display: flex;
  justify-content: center;
  cursor: auto;
}
</style>
